import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "equipment-detail row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row wrap text-center" }, "Please select the Equipment", -1 /* HOISTED */)
const _hoisted_3 = { class: "row justify-between col-12" }
const _hoisted_4 = { class: "col-8" }
const _hoisted_5 = { class: "col-4" }
const _hoisted_6 = { class: "row justify-between col-12" }
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = { class: "col-2 links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_EquipmentStatusCurrentCard = _resolveComponent("EquipmentStatusCurrentCard")!
  const _component_EquipmentKPIsCard = _resolveComponent("EquipmentKPIsCard")!
  const _component_EquipmentStatusHistoryCard = _resolveComponent("EquipmentStatusHistoryCard")!
  const _component_EquipmentLinksCard = _resolveComponent("EquipmentLinksCard")!
  const _component_EquipmentBarchartKPIsCard = _resolveComponent("EquipmentBarchartKPIsCard")!
  const _component_EquipmentEventsCard = _resolveComponent("EquipmentEventsCard")!
  const _component_SparePartsCard = _resolveComponent("SparePartsCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageTitle, {
      title: "Equipment detail",
      page: _ctx.pageEnum.EquipmentDetail
    }, null, 8 /* PROPS */, ["page"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.getEquipmentDetails)
        ? (_openBlock(), _createBlock(_component_q_card, {
            key: 0,
            class: "q-mb-lg col-12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "row justify-center card-title" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_EquipmentStatusCurrentCard, { equipment: _ctx.getEquipmentDetails }, null, 8 /* PROPS */, ["equipment"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_EquipmentKPIsCard, { equipment: _ctx.getEquipmentDetails }, null, 8 /* PROPS */, ["equipment"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_EquipmentStatusHistoryCard, {
            equipment: _ctx.getEquipmentDetails,
            onOnClickTimelineStatus: _ctx.onClickTimelineStatus
          }, null, 8 /* PROPS */, ["equipment", "onOnClickTimelineStatus"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_EquipmentLinksCard, { equipment: _ctx.getEquipmentDetails }, null, 8 /* PROPS */, ["equipment"])
        ])
      ]),
      (
          _ctx.getEquipmentDetails?.equipmentModel?.system ===
          _ctx.equipmentSystemEnum.TRANSFORMERS
        )
        ? (_openBlock(), _createBlock(_component_EquipmentBarchartKPIsCard, {
            key: 1,
            equipment: _ctx.getEquipmentDetails
          }, null, 8 /* PROPS */, ["equipment"]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_EquipmentEventsCard, {
        equipment: _ctx.getEquipmentDetails,
        "status-id-filter": _ctx.clickedStatusId,
        onOnFilterReset: _ctx.onFilterEventsReset
      }, null, 8 /* PROPS */, ["equipment", "status-id-filter", "onOnFilterReset"]),
      _createVNode(_component_SparePartsCard, { equipment: _ctx.getEquipmentDetails }, null, 8 /* PROPS */, ["equipment"])
    ])
  ]))
}